<template>
  <div>
    <ResizeAuto>
      <template v-slot:default="{ resize }">
        <b-form-textarea
          @input="resize"
          @focus="resize"
          v-model.trim="text"
          @keydown.enter="updateTextArea"
        ></b-form-textarea>
      </template>
    </ResizeAuto>
    <div v-if="showSaveBtn" class="row">
      <b-form-group
        v-if="show_last_modification == true"
        label-for="input-modification-date"
        label-cols="0"
        label-cols-sm="0"
        class="p-0 m-0 mt-2 ml-3"
      >
        <ModificationDate
          v-if="!isNaN(object_last_modification.id)"
          :Information="object_last_modification"
        ></ModificationDate>
      </b-form-group>
      <div class="col mt-1" style="text-align: right">
        <b-button class="mr-0" size="sm" @click="update">
          {{ $t("reusable.common.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ResizeAuto from "@/components/reusable/ResizeAuto";

export default {
  name: "TextArea",
  components: {
    ResizeAuto,
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    Text: {
      type: String,
      default: "",
    },
    showSaveBtn: {
      type: Boolean,
      default: false,
    },
    clearTextArea: {
      type: Boolean,
      default: true,
    },
    prevent_update: {
      type: Boolean,
      default: true,
    },
    show_last_modification: {
      type: Boolean,
      default: false,
    },
    object_last_modification: {
      type: Object,
    },
  },
  data() {
    return {
      text: this.Text,
    };
  },
  methods: {
    updateTextArea() {
      if (this.prevent_update === false) this.update();
    },
    update() {
      if (this.text != this.Text) this.$emit("update", this.text.trim());
      if (this.clearTextArea) this.text = "";
    },
  },
  // watch: {
  //   text: function () {
  //     this.text = this.text.replace(
  //       /\d\.\s+|•\s+|[A-Z]\.\s+|[IVX]+\.\s+/g,
  //       ""
  //     );
  //   },
  // },
};
</script>

<style scoped>
label {
  cursor: pointer;
}
textarea {
  width: 100%;
  border: 1px solid var(--secondary-color);
}
</style>